module.exports = __webpack_public_path__ + "img/Website background image wreath.7bc80a88.png";